import { toastWithAnalytics } from '../analytics';

export interface ErrorResponse {
  type: string;
  title: string;
  status: number;
  detail: string;
  traceId: string;
  ErrorCode: string;
  Value: string;
}
export default function errorFromResponse(err: ErrorResponse) {
  if (err && err?.Value) {
    const val = JSON.parse(err.Value);
    if (val?.detail) {
      const details = JSON.parse(val.detail);
      let msg = details.message?.replaceAll('qty', 'quantity');
      if (
        details?.parameters &&
        Array.isArray(details?.parameters) &&
        details.parameters.length > 0
      ) {
        details.parameters.map((v: string, i: number) => {
          msg = msg.replace(`%${i + 1}`, v);
          return v;
        });
        toastWithAnalytics(msg, 'danger');
      } else {
        toastWithAnalytics(msg, 'danger');
      }
    }
  }
}
